export const COMBO_PROMOCIONAL_SAVE = "COMBO_PROMOCIONAL_SAVE";
export const COMBO_PROMOCIONAL_UPDATE = "COMBO_PROMOCIONAL_UPDATE";
export const COMBO_PROMOCIONAL_SAVE_ITENS = "COMBO_PROMOCIONAL_SAVE_ITENS";
export const COMBO_PROMOCIONAL_LOAD = "COMBO_PROMOCIONAL_LOAD";
export const COMBO_PROMOCIONAL_REMOVE = "COMBO_PROMOCIONAL_REMOVE";
export const COMBO_PROMOCIONAL_CONFIG = "COMBO_PROMOCIONAL_CONFIG";
export const COMBO_PROMOCIONAL_ITENS_LOAD = "COMBO_PROMOCIONAL_ITENS_LOAD";
export const COMBO_PROMOCIONAL_LOAD_IMAGES = "COMBO_PROMOCIONAL_LOAD_IMAGES";
export const COMBO_PROMOCIONAL_REMOVE_IMAGE = "COMBO_PROMOCIONAL_REMOVE_IMAGE";
